(() => {
  if (window.gwSideSetting) return;
  const feeId = 67836958408756;
  const feeIds = [feeId, 67837168025652];
  async function reconcile(cart, sections = []) {
    let changed = false;
    for (let attempt = 0; attempt < 20; attempt++) {
      const child = cart.items.find((item) => {
        if (!feeIds.includes(Number(item.variant_id || item.id))) return false;
        const parent = cart.items.find((line) => line.key === item.parent_relationship?.parent_key);
        return !parent || item.quantity !== parent.quantity;
      });
      if (!child) return { cart, changed };
      const parent = cart.items.find((item) => item.key === child.parent_relationship?.parent_key);
      const response = await fetch((window.Shopify?.routes.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: child.key, quantity: parent ? parent.quantity : 0, sections, sections_url: window.location.pathname })
      });
      const data = await response.json();
      if (!response.ok || data.status || data.errors || !Array.isArray(data.items)) throw new Error('Could not confirm the side-diamond setting charge. Please refresh your cart.');
      cart = data;
      changed = true;
    }
    throw new Error('Please refresh your cart to confirm side-diamond setting.');
  }
  window.gwSideSetting = { feeId, feeIds, reconcile };
})();

(() => {
  if (window.gwRingSizing) return;
  const feeId = 67711779536948;
  const sizeKey = 'Requested ring size (US)';
  const isFee = (item) => Number(item.variant_id || item.id) === feeId;
  const size = (item) => String(item.properties?.[sizeKey] || '').trim();
  const validSize = (value) => Number(value) >= .25 && Number.isFinite(Number(value)) && Math.abs(Number(value) * 4 - Math.round(Number(value) * 4)) < 1e-7;
  function withFee(item) {
    const requested = size(item);
    if (!requested) return [item];
    if (!validSize(requested)) throw new Error('Choose a valid US ring size in quarter-size increments.');
    if (!Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error('Choose a valid quantity.');
    return [item, {id: feeId, quantity: item.quantity, parent_id: Number(item.id), properties: {[sizeKey]: requested, _gwSizingService: 'true'}}];
  }
  function mismatch(cart, strict = true) {
    for (const child of cart.items.filter(isFee)) {
      const parent = cart.items.find((item) => item.key === child.parent_relationship?.parent_key);
      if (!parent || !size(parent)) return {parent, child};
    }
    for (const parent of cart.items.filter((item) => !isFee(item) && size(item))) {
      const children = cart.items.filter((item) => isFee(item) && item.parent_relationship?.parent_key === parent.key);
      if (!strict && children.length === 0) continue;
      if (children.length !== 1 || children[0].quantity !== parent.quantity || size(children[0]) !== size(parent)) return {parent, child: children[0]};
    }
    return null;
  }
  async function request(path, payload) {
    const response = await fetch((window.Shopify?.routes.root || '/') + path, {method: payload ? 'POST' : 'GET', headers: {'Content-Type':'application/json', Accept:'application/json'}, ...(payload ? {body:JSON.stringify(payload)} : {})});
    const data = await response.json();
    if (!response.ok || data.status || data.errors) throw new Error('Could not confirm the $25 ring-sizing charge. Please refresh your cart.');
    return data;
  }
  async function reconcile(cart, sections = [], {strict = true} = {}) {
    let changed = false;
    for (let attempt = 0; attempt < 20; attempt++) {
      const problem = mismatch(cart, strict);
      if (!problem) return {cart, changed};
      const {parent, child} = problem;
      if (!parent) throw new Error('A ring-sizing charge has no matching ring. Please refresh your cart before checkout.');
      if (cart.items.filter((item) => isFee(item) && item.parent_relationship?.parent_key === parent.key).length > 1) throw new Error('Multiple sizing charges were found. Remove this ring and add it again before checkout.');
      if (!validSize(size(parent))) throw new Error('Please confirm your requested ring size before checkout.');
      if (child) {
        const line = cart.items.indexOf(child) + 1;
        cart = await request('cart/change.js', {line, quantity:parent.quantity, properties:{[sizeKey]:size(parent), _gwSizingService:'true'}, sections, sections_url:window.location.pathname});
      } else {
        throw new Error('This ring is missing its $25 sizing charge. Remove it and add it again with your requested size before checkout.');
      }
      changed = true;
    }
    throw new Error('Please refresh your cart to confirm ring sizing.');
  }
  function exactParent(cart, key) {
    const index = cart.items.findIndex((item) => item.key === key);
    if (index < 0) throw new Error('Your cart changed. Refresh it and try again.');
    return {item:cart.items[index], line:index + 1};
  }
  async function setCartSize(key, requested) {
    if (requested && !validSize(requested)) throw new Error('Choose a valid US ring size in quarter-size increments.');
    let cart = await request('cart.js');
    let {item: parent} = exactParent(cart, key);
    if (isFee(parent)) throw new Error('Please adjust sizing on the ring itself.');
    const existing = size(parent);
    if (existing === requested) return cart;
    if (existing) {
      const children = cart.items.filter((item) => isFee(item) && item.parent_relationship?.parent_key === parent.key);
      if (children.length !== 1) throw new Error('Please refresh the cart to confirm its sizing charge.');
      cart = await request('cart/change.js', {line:cart.items.indexOf(children[0]) + 1, quantity:0});
      parent = exactParent(cart, key).item;
    }
    const properties = {...(parent.properties || {})};
    delete properties[sizeKey];
    if (requested) {
      properties[sizeKey] = requested;
      properties._gwSizingCartLine = properties._gwSizingCartLine || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      delete properties._gwSizingRemoved;
    } else if (!Object.keys(properties).length) {
      // Ajax cart/change cannot clear every property from a line.
      properties._gwSizingRemoved = 'true';
    }
    cart = await request('cart/change.js', {line:exactParent(cart, parent.key).line, quantity:parent.quantity, properties});
    if (requested) {
      const updated = cart.items.find((item) => !isFee(item) && item.properties?._gwSizingCartLine === properties._gwSizingCartLine && size(item) === requested);
      if (!updated) throw new Error('Could not confirm the ring size. Refresh your cart and try again.');
      cart = await request('cart/add.js', {items:[{id:feeId, quantity:updated.quantity, parent_line_key:updated.key, properties:{[sizeKey]:requested, _gwSizingService:'true'}}]});
      cart = await request('cart.js');
    }
    if (mismatch(cart)) throw new Error('Could not confirm ring sizing. Refresh your cart before checkout.');
    return cart;
  }
  window.gwRingSizing = {feeId, sizeKey, withFee, mismatch, reconcile, setCartSize};
  async function updateCartSize(control, requested) {
    const row = control.closest('.cart-item');
    const widget = control.closest('[data-gw-cart-size]');
    const error = widget.querySelector('[data-gw-size-error]');
    if (window.gwCartMutationPending) return;
    error.hidden = true;
    window.gwCartMutationPending = true;
    widget.setAttribute('aria-busy','true');
    try {
      await setCartSize(row.dataset.lineKey, requested);
      window.location.reload();
    } catch (e) {
      error.textContent = e.message;
      error.hidden = false;
      widget.querySelector('[data-gw-size-toggle]').checked = Boolean(widget.dataset.originalSize);
      widget.querySelector('[data-gw-size-edit]').hidden = !widget.dataset.originalSize;
      const latest = await request('cart.js').catch(() => null);
      if (latest) {
        const item = latest.items.find((entry) => entry.key === row.dataset.lineKey);
        if (!item || size(item) !== widget.dataset.originalSize) window.location.reload();
      }
    } finally {
      window.gwCartMutationPending = false;
      widget.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('change',(event) => {
    const checkbox = event.target.closest?.('[data-gw-size-toggle]');
    if (!checkbox) return;
    const widget = checkbox.closest('[data-gw-cart-size]');
    widget.querySelector('[data-gw-size-edit]').hidden = !checkbox.checked;
    if (!checkbox.checked) updateCartSize(checkbox, '');
  },true);
  document.addEventListener('click',(event) => {
    const apply = event.target.closest?.('[data-gw-size-apply]');
    if (apply) updateCartSize(apply, apply.closest('[data-gw-cart-size]').querySelector('[data-gw-size-value]').value.trim());
  },true);
  let checking = false;
  async function checkout(event) {
    const control = event.target.closest?.('[name="checkout"],a[href$="/checkout"]');
    if (!control) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (checking) return;
    checking = true;control.setAttribute('aria-busy','true');
    try {
      const deadline = Date.now() + 10000;
      while (window.gwCartMutationPending && Date.now() < deadline) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      if (window.gwCartMutationPending) throw new Error(control.dataset.gwCartUpdating || 'Your cart is updating. Please try Checkout again in a moment.');
      if ([...document.querySelectorAll('[data-gw-cart-size]')].some((widget) => {
        if (!widget.querySelector('[data-gw-size-toggle]').checked) return false;
        const edited = widget.querySelector('[data-gw-size-value]')?.value.trim() || '';
        const saved = widget.dataset.originalSize || '';
        return !saved || !edited || Number(edited) !== Number(saved);
      })) {
        throw new Error(control.dataset.gwSizeUnapplied || 'Apply your edited ring size before checkout, or turn off custom sizing.');
      }
      const result = await reconcile(await request('cart.js'));
      if (mismatch(result.cart)) throw new Error('Ring sizing has not been confirmed.');
      if (window.gwSideSetting) await window.gwSideSetting.reconcile(result.cart);
      window.location.assign((window.Shopify?.routes.root || '/') + 'checkout');
    } catch(error) {
      let status = document.querySelector('[data-gw-sizing-error]');
      if (!status) {status=document.createElement('p');status.dataset.gwSizingError='';status.setAttribute('role','alert');control.insertAdjacentElement('beforebegin',status);}
      status.textContent=error.message;checking=false;control.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click',checkout,true);
  document.addEventListener('submit',(event)=>{if(event.submitter?.name==='checkout') checkout({target:event.submitter,preventDefault:()=>event.preventDefault(),stopImmediatePropagation:()=>event.stopImmediatePropagation()});},true);
})();

